"use client";

import { useEffect, useState } from "react";
import { Box, Typography, styled } from "@mui/material";
import { SummarySkeleton } from "../skeletons/SummarySkeleton";

const MESSAGES = [
  "Analysing candidate details",
  "Preparing outreach recommendations",
  "Identifying suitable company recommendations",
  "Generating candidate summary",
];

const ROTATE_MS = 3500;

const Wrap = styled(Box)({
  position: "relative",
});

const Overlay = styled(Box)({
  position: "absolute",
  inset: 0,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  pointerEvents: "none",
  textAlign: "center",
  padding: "0 16px",
  transform: "translateY(-14px)",
});

export default function SummaryLoading() {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const id = setInterval(() => {
      setIndex((i) => (i + 1) % MESSAGES.length);
    }, ROTATE_MS);
    return () => clearInterval(id);
  }, []);

  return (
    <Wrap>
      <SummarySkeleton />
      <Overlay aria-live="polite">
        <Typography variant="body1">{MESSAGES[index]}…</Typography>
      </Overlay>
    </Wrap>
  );
}
